export default __webpack_public_path__ + "static/media/order-arrived-bag.a0a2a3ae.gif";